import assert from 'assert';
import {IS_CLIENT_SIDE} from '../utils/constants';

/**
 * 샌드박스 카카오 SDK를 동적으로 import 하는 함수
 *
 * 브라우저에서만 호출해야 합니다.
 */
export async function importSandboxKakaoSdk() {
  assert(IS_CLIENT_SIDE);

  if (!Object.prototype.hasOwnProperty.call(window, 'Kakao')) {
    // @ts-ignore
    await import('../../../../public/public/js/sandbox-kakao.min.js');
  }
  if (!(window as any).Kakao.isInitialized()) {
    (window as any).Kakao.init('e4b3c374d91cdeeabd270f7feed5dc01');
  }
}
